import cookie from 'vue-cookies'
import { db, auth, FieldPath } from '@/firebaseConfig'
import { denormalized } from '@/helpers'

const state = {
  companyId: null,
  currentCompany: null,
  roles: [],
  subscriptions: [],
  currentUserWorkforceInfo: null,
  userCompanies: [],
  userCompaniesLoading: false
}

const getters = {
  currentCompany: (state) => {
    return state.currentCompany
  },
  companyId: (state) => {
    if (state.companyId == null) {
      if (cookie.isKey('company_id')) {
        state.companyId = cookie.get('company_id')
        return state.companyId
      }
    } else {
      return state.companyId
    }

    return null
  },
  activeSubscription: (state) => {
    const activeSubStatuses = ['active', 'trialing']
    return state.subscriptions.filter((s) => activeSubStatuses.includes(s.status))[0]
  },
  companyRoles: (state) => {
    return state.roles
  },
  currentUserWorkforceInfo: (state) => {
    return state.currentUserWorkforceInfo
  },
  userCompanies: (state) => {
    return state.userCompanies
  },
  userCompaniesLoading: (state) => {
    return state.userCompaniesLoading
  }
}

const mutations = {
  setCurrentCompany(state, newValue) {
    state.currentCompany = newValue
    if (newValue == null) {
      cookie.remove('company_id')
      state.companyId = null
    } else {
      cookie.set('company_id', newValue.id, Infinity)
      state.companyId = newValue.id
    }
  },
  setCompanyId(state, newValue) {
    cookie.set('company_id', newValue.id, Infinity)
    state.companyId = newValue.id
  },
  setRoles(state, newValue) {
    state.roles = newValue
  },
  setSubscriptions(state, newValue) {
    state.subscriptions = newValue
  },
  setCurrentUserWorkforceInfo(state, newValue) {
    state.currentUserWorkforceInfo = newValue
  },
  setUserCompanies(state, newValue) {
    state.userCompanies = newValue
  },
  setUserCompaniesLoading(state, newValue) {
    state.userCompaniesLoading = newValue
  }
}

const actions = {
  async getCompanyInfo({ commit, dispatch }, id) {
    try {
      const docSnapshot = await db.collection('companies').doc(id).get()
      if (docSnapshot.exists) {
        let data = docSnapshot.data()
        data.id = id
        commit('setCurrentCompany', data)
        await dispatch('loadCompanyRelatedData')
      } else {
        console.error('No info for company')
      }
     
    } catch (error) {
      console.error(error)
    }
  },
  async loadCompanyRelatedData({ dispatch }) {
    try {
      await dispatch('getRoles')
      await dispatch('getSubscriptions')
      await dispatch('getCurrentUserWorkforceInfo')
    } catch (error) {
      console.error(error)
    }
  },
  getCurrentUserWorkforceInfo({commit, state}) {
    if (!state.companyId) {
      return
    }
    return db.collection(`companies/${state.companyId}/workforce`).doc(auth.currentUser.uid).get().then(snap => {
      if (snap.exists) {
        commit('setCurrentUserWorkforceInfo', denormalized.workforce(snap.data(), snap.id))
      }
    })
  },
  async getRoles({commit, state}) {
    if (!state.companyId) {
      return
    }
    try {
      const snap = await db.collection(`companies/${state.companyId}/roles`).get()
      const roles = []
      snap.docs.forEach(doc => {
        const data = doc.data()
        Object.defineProperty(data, 'id', {
          value: doc.id
        })
        Object.defineProperty(data, 'ref', { value: doc.ref })
        roles.push(data)
      })
      commit('setRoles', roles)
    } catch (error) {
      console.error(error)
    }
    
    
  },
  async getSubscriptions({commit, state}) {
    if (!state.companyId) {
      return
    }

    try {
      const snap = await db.collection(`companies/${state.companyId}/subscriptions`).get()
      const subscriptions = []
      snap.docs.forEach(doc => {
        const data = doc.data()
        Object.defineProperty(data, 'id', {
          value: doc.id
        })
        subscriptions.push(data)
      })
      commit('setSubscriptions', subscriptions)
    } catch (error) {
      console.error(error)
    }
    
    
  },

  async getUserCompanies({ commit }, scopes) {
    commit('setUserCompaniesLoading', true)

    try {
      if (!scopes || scopes.length === 0) {
        return []
      }
      let companyIds = scopes.map((sc) => /^companies\.(.*?)\..*$/.exec(sc)[1])
      companyIds = [...new Set(companyIds)]

      const snapshot = await db.collection('companies').where(FieldPath.documentId(), 'in', companyIds).get()
      const companies = snapshot.docs.map((c) => {
        return {
          id: c.id,
          ...c.data(),
        }
      })

      commit('setUserCompanies', companies)
    } catch (error) {
      console.error(error)
    } finally {
      commit('setUserCompaniesLoading', false)
    }
  },

  clearCompanyData({ commit }) {
    commit('setCurrentCompany', null)
    commit('setRoles', [])
    commit('setSubscriptions', [])
    commit('setCurrentUserWorkforceInfo', null)
  },
  setCompanyId({ commit, dispatch }, id) {
    commit('setCompanyId', id)
    dispatch('getCompanyInfo', id)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
